import React, { useState } from 'react';
import { Button } from 'components/shadcn/ui/button';
import { UndoIcon } from 'lucide-react';

const DetachSiteButton = ({ initialValues, setFieldValue }) => {
    const [detached, setDetached] = useState(false);
    const handleDetachSite = () => {
        const siteAttachedTo = detached
            ? initialValues?.siteAttachedTo
            : 'marked for detachment';
        setFieldValue('siteAttachedTo', siteAttachedTo);
        setDetached(!detached);
    };

    return (
        <Button
            type="button"
            variant="outline"
            onClick={handleDetachSite}
            className='absolute bottom-0 right-0 capitalize rounded-l-none '
        >
            {detached ? (
                <>
                    <UndoIcon className='w-4 h-4 mr-1' />
                    undo
                </>
            ) : (
                'detach'
            )}
        </Button>
    );
};

export default DetachSiteButton;
